import { useLocation } from '@remix-run/react';
import type { RSSFeedDataPodcast, RSSFeedDataYouTube, TRSSFeedElement } from '@shared/dream-components';
import type { RSSFeedDataPodcastShow } from '@shared/dream-components/src/types';

import useTypedLoaderData from '~/hooks/useUtils/useTypedLoaderData';
import type { PodcastShowEpisodePageLoaderData } from '~/routes/podcast/s/$showSlug/$episodeSlug';

export const useRssFeedData = (node: TRSSFeedElement, rssFeed: RSSFeedDataPodcast | RSSFeedDataYouTube | undefined) => {
  const location = useLocation();
  const loaderData = useTypedLoaderData<PodcastShowEpisodePageLoaderData>();
  const isPodcastEpisodePage = location.pathname.startsWith('/podcast/');

  if (node.attrs.hasMigratedToCardStructure && node.attrs.source === 'beehiiv_podcast_show') {
    if (isPodcastEpisodePage) {
      return { episodes: loaderData?.podcastEpisode?.show?.recent_episodes } as RSSFeedDataPodcastShow;
    }

    return { episodes: node.attrs.selectedPodcastShowEpisodes ?? [] };
  }

  return rssFeed || (node.attrs.data as RSSFeedDataYouTube | RSSFeedDataPodcast);
};
